<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 top-14 flex items-end px-4 py-6 sm:items-start sm:p-6 z-10">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <div
          v-if="displayedNotification"
          class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-neutral-800 shadow-lg ring-1 ring-black/5 dark:ring-neutral-700/5"
          @mouseover="stopAutoHideTimer"
          @mouseout="startAutoHideTimer">
          <div class="p-4">
            <div class="flex items-start">
              <div class="shrink-0">
                <i
                  class="fa-sharp fa-regular text-neutral-500 dark:text-neutral-300 fa-fw text-xl"
                  :class="displayedNotification.data.icon"
                  aria-hidden="true"></i>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm font-medium text-neutral-900 dark:text-neutral-100">
                  {{ displayedNotification.data.title }}
                </p>
                <p v-if="displayedNotification.office_id" class="mb-1 text-xs uppercase text-neutral-500">
                  {{ officeName || 'Unknown Office' }}
                </p>
                <p
                  v-if="displayedNotification.data.description"
                  class="mt-3 text-sm text-neutral-500 dark:text-neutral-400">
                  {{ displayedNotification.data.description }}
                </p>
                <div class="mt-3 flex space-x-7">
                  <button
                    v-if="!!linkRoute"
                    type="button"
                    @click="viewDetail"
                    class="rounded-md bg-white dark:bg-neutral-800 text-sm font-medium text-accent-600 hover:text-accent-500 focus:outline-hidden focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 dark:ring-offset-neutral-800">
                    {{ displayedNotification.data.label }}
                  </button>
                  <button
                    type="button"
                    class="rounded-md bg-white dark:bg-neutral-800 text-sm font-medium text-neutral-700 dark:text-neutral-400 hover:text-neutral-500 dark:hover:text-white dark:ring-offset-neutral-800 focus:outline-hidden focus:ring-2 focus:ring-accent-500 focus:ring-offset-2"
                    @click="dismiss">
                    Dismiss
                  </button>
                </div>
              </div>
              <div class="ml-4 flex shrink-0">
                <button
                  type="button"
                  @click="dismiss"
                  class="w-6 h-6 inline-flex justify-center items-center rounded-md bg-white dark:bg-neutral-800 text-neutral-400 hover:text-neutral-500 dark:hover:text-white focus:outline-hidden focus:ring-2 focus:ring-accent-500 dark:ring-offset-neutral-800 focus:ring-offset-2">
                  <span class="sr-only">Close</span>
                  <i class="fa-sharp fa-times fa-fw" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { useNotificationStore } from '@/stores/notifications'
import { useSystemStore } from '@/stores/system'
import { mapActions, mapState } from 'pinia'

export default {
  computed: {
    ...mapState(useSystemStore, ['hub']),
    ...mapState(useAuthStore, ['authOffices', 'selectedOffice']),
    ...mapState(useNotificationStore, ['displayedNotification', 'notificationAutoCloseTimer']),
    officeName() {
      if (!this.displayedNotification) {
        return
      }

      const office = this.authOffices.find((o) => o.id === this.displayedNotification.office_id)
      if (!office) {
        return
      }

      return office?.name
    },
    linkRoute() {
      if (!this.displayedNotification?.data.module) {
        return null
      }

      return this.$routeToModule(this.displayedNotification.data.module, this.displayedNotification.data.route_params)
    }
  },
  methods: {
    ...mapActions(useNotificationStore, [
      'dismissNotification',
      'deleteNotification',
      'markNotificationAsRead',
      'startAutoHideTimer',
      'stopAutoHideTimer'
    ]),
    ...mapActions(useAuthStore, ['switchOffice']),
    async viewDetail() {
      const id = this.displayedNotification.id
      if (this.displayedNotification.office_id && this.displayedNotification.office_id !== this.selectedOffice.id) {
        await this.switchOffice(this.displayedNotification.office_id)
      }
      this.$router.push(this.linkRoute)
      this.dismissNotification()
      this.deleteNotification(id)
    },
    dismiss() {
      const id = this.displayedNotification.id
      this.dismissNotification()
      this.markNotificationAsRead(id)
    }
  }
}
</script>
